import { GetAIResultsPayload } from 'app/modules/aiAgentResults/requests';

const BASE = ['aiAgentResults'] as const;

export const AI_AGENT_RESULTS_QUERY_KEYS = {
  getAIResults: (payload: GetAIResultsPayload) =>
    [...BASE, 'results', payload] as const,
  verifyConfiguration: () => [...BASE, 'verify'] as const,
};
